import React from "react";

export default function Twitter() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.909091 0C0.407014 0 0 0.407015 0 0.909091V19.0909C0 19.593 0.407015 20 0.909091 20H19.0909C19.593 20 20 19.593 20 19.0909V0.909091C20 0.407014 19.593 0 19.0909 0H0.909091ZM17.6548 1.81666L11.5609 8.7476L18.1856 18.1833H13.3116L8.84898 11.828L3.2625 18.1833H1.81895L8.20905 10.916L1.81895 1.81666H6.69295L10.9177 7.83347L16.2113 1.81666H17.6548ZM6.00119 2.88178H3.7835L13.9919 17.1705H16.2102L6.00119 2.88178Z" fill="#313751"/>
    </svg>
  );
}
